import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "var(--color-black)",
  viewBox: "0 0 16 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M7.25 9.25c0 .41.336.75.75.75s.75-.34.75-.75v-3.5C8.75 5.34 8.414 5 8 5s-.75.34-.75.75zM8 12.3a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5" }, null, -1),
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      d: "M9.515 2.125c-.673-1.167-2.357-1.167-3.03 0l-5.63 9.75c-.673 1.167.169 2.625 1.516 2.625h11.258c1.347 0 2.19-1.458 1.516-2.625zM13.89 12.4 8.433 2.95a.5.5 0 0 0-.866 0L2.11 12.4a.5.5 0 0 0 .433.75h10.912a.5.5 0 0 0 .433-.75",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }